import React from 'react';
import { InfoOutline } from '@sparkpost/matchbox-icons';
import { Tooltip } from 'src/components/matchbox';
import useUniqueId from 'src/hooks/useUniqueId';
import styles from './DataCell.module.scss';

const WoWHeaderCell = () => {
  const id = useUniqueId('wow-header-cell');

  return (
    <Tooltip id={id} content="Week Over Week Change" dark>
      WoW <InfoOutline size={15} className={styles.InfoIcon} />
    </Tooltip>
  );
};

export default WoWHeaderCell;
